import React from 'react'
import Banner from './banner'
import Roots from './roots'
import BannerImg from '../../assets/landing_two.png'
import Mission from './mission'
import Growth from './growth'
import { missionData } from '../../utils/fakeData'
import GrowthCard from '../../components/growthCard'

const AboutUs = () => {

    return (
        <div >
            <Banner />
            <Roots />
            <div className='md:relative h-auto md:h-[1100px]  !bg-cover !bg-bottom mt-10 !bg-no-repeat'
                style={{
                    background: `url(${BannerImg})`,

                }}
            >

                <Mission />
            </div>
            <div className="grid md:hidden grid-cols-1 gap-6 my-8 px-4">
                {missionData.map((item, index) => (
                    <div key={index} className="mt-2">
                        <GrowthCard item={item} />
                    </div>
                ))}
            </div>
            {/* <Growth /> */}

        </div>
    )
}

export default AboutUs
